import { render, staticRenderFns } from "./TaskAssigneePicker.vue?vue&type=template&id=6a74a638&scoped=true&"
import script from "./TaskAssigneePicker.vue?vue&type=script&lang=js&"
export * from "./TaskAssigneePicker.vue?vue&type=script&lang=js&"
import style0 from "./TaskAssigneePicker.vue?vue&type=style&index=0&id=6a74a638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74a638",
  null
  
)

export default component.exports